var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"mt-3",attrs:{"variant":"outline-secondary"},on:{"click":_vm.goBack}},[_c('i',{staticClass:"icon-arrow-left mr-1"}),_vm._v(" "+_vm._s(_vm.$t('other.return'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }